<template>
    <div>
        <v-layout>
            <v-flex>
                <v-autocomplete
                    :loading="loading"
                    :items="items"
                    :search-input.sync="search"
                    v-model="model"
                    item-text="name" item-value="name"
                    return-object
                    hide-no-data
                    :label="label"
                    :rules="rules"
                    @input="changed"
                    @dblclick.native="querySelections('?')"
                    v-bind="$attrs"
                    no-filter
                    :disabled="!!isModeNew"
                    ref="searchbox"
                >
                    <template v-slot:selection="{ item, selected }">
                        <v-avatar v-if="item.metadata.is_new_wms && !isGeneratedNew" tile size="24" color="green lighten-1" class="white--text mr-3">TP</v-avatar>
                        <span>{{ item.name }}</span>
                    </template>
                    <template v-slot:item="{ item }">
                        <template v-if="!item.customer">
                            <v-list-tile-avatar color="orange" class="white--text">+</v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>+ {{ $t('New customer') }}</v-list-tile-title>
                            </v-list-tile-content>
                        </template>
                        <template v-else>
                            <v-list-tile-avatar v-if="item.metadata.is_new_wms" tile color="green lighten-1" class="white--text">TP</v-list-tile-avatar>
                            <v-list-tile-avatar v-else                          tile color="blue"            class="white--text">WMS</v-list-tile-avatar>
                            <v-list-tile-content >
                                <v-list-tile-title>
                                    {{ item.customer.name }}
                                    <span v-if="item.customer.code" class="grey--text text--darken-1 font-weight-light" style="float: right">{{ $t('Code') + ': ' + item.customer.code }}</span>
                                </v-list-tile-title>
                                <v-list-tile-sub-title v-html="item.customer.address"></v-list-tile-sub-title>
                            </v-list-tile-content>
                        </template>
                    </template>
                </v-autocomplete>
            </v-flex>
            <v-flex shrink>
                <v-tooltip bottom>
                    <v-icon slot="activator"
                        @click="!!isModeNew ? enterSearch() : getCode()"
                        v-text="!!isModeNew ? 'search' : 'person_add'"
                        class="ml-1 mt-3"
                    ></v-icon>
                    {{ !!isModeNew ? $t('Search customer') : $t('New customer') }}
                </v-tooltip>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import { debounce } from 'lodash';
import { wms }  from '@/resources';

export default {
    name: 'suggest-customer',
    props: {
        label: {
            type: String
        },
        rules: {
            type: Array
        },
    },
    data() {
        return {
            loading: false,
            items: [],
            search: '',
            model: null,
            isModeNew: false
        }
    },
    computed: {
        customerName() {
            // return this.model && this.model.customer && this.model.customer.name || null;
            return this.model && this.model.name || null;
        },
        isGeneratedNew() {
            return this.model && !this.model.customer && (this.model.metadata && this.model.metadata.generated_code);
        }
    },
    watch: {
        search(val) {
            console.log('search', val);
            this.suggest(val);
        },
    },
    methods: {
        suggestImpl(val) {
            console.log('SuggestImpl('+val+')', (
                val && val !== this.customerName
            ));
            if (val && val !== this.customerName) {
                this.querySelections(val);
            }
            if (typeof this.model === 'undefined') {// Fix suggestment break when clear-btn sets model=undefined
                this.model = null;
            }
        },
        querySelections(q) {
            console.log('doSuggest ' + q);
            this.loading = true;
            wms.suggestCustomer({q}).then(result => {

                const generated_code = result.body.generated_code;

                let items = result.body.suggestions.map((elem, idx) => {
                    elem.metadata.is_new_wms = !elem.customer.code;// wms_code
                    elem.metadata.generated_code = generated_code;
                    elem.name = elem.customer.name;
                    return elem;
                });
                items.unshift({
                    name: '',
                    metadata: {
                        is_new_wms: true,
                        generated_code
                    },
                });
                this.items = items;

            }).catch((err) => {
                console.log('Error suggesting customer ', err);
            }).finally(() => {
                this.loading = false;
            });
        },
        changed() {
            console.log('changed');
            this.$emit('input', this.model);
        },

        enterSearch() {
            this.model = {};
            this.isModeNew = false;
            setTimeout(() => {
                this.$refs.searchbox.focus();
            }, 500);
        },
        /*-------------------- Generate code --------------------*/
        getCode() {
            wms.generateCustomerCode().then(result => {
                const generated_code = result.body.generated_code;
                this.model = {
                    metadata: {
                        is_new_wms: true,
                        generated_code
                    },
                };
                this.changed();
                this.isModeNew = true;

            }).catch((err) => {
                console.log('Error generate customer code ', err);
            }).finally(() => {
                this.loading = false;
            });
        }
    },

    created() {
        this.suggest = debounce(this.suggestImpl, 400);
    }
}
</script>